import BaseAiService from '@src/slide/application/service/ai/core/base/base-ai-service';
import { ESource } from '@tencent/ai-sdk-interface';
import { IMobileAiService, IMobileAIServiceDelegates } from '@src/slide/application/service/ai/core/mobile/mobile-ai-service.interface';
import { getAiAssistant } from '@src/js/common/ark-extensions/dc-components/ai-assistant-mobile';
import type { AIMobileController } from '@tencent/ai-sidebar-sdk';
import * as reporter from '../../../ai-controller/core/base/report';
import { showPanel } from './ai-panel';

export default class MobileAiService extends BaseAiService implements IMobileAiService {
    protected declare services: IMobileAIServiceDelegates;

    public constructor() {
        super();
    }

    public async showSideBar() {
        super.showSideBar();
        // 移动端上报 AI 入口点击
        reporter.reportAIEntranceClick();
    }

    public async showPanel() {
        showPanel(this, this.services?.mobileRatingService);
    }

    protected async createAIController(): Promise<AIMobileController> {
        const aiAssistant = await getAiAssistant();
        this.registerDocsApi(aiAssistant.api);
        return aiAssistant.initialize({
            context: { clientVars: {} },
            source: ESource.SOURCE_SLIDE,
            lifecycles: {
                onShow: () => {
                    this.aiLifeCyclesFunction?.onShow?.();
                },
                onHide: () => {
                    this.aiLifeCyclesFunction?.onHide?.();
                },
            },
        });
    }
}
